<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view class="Router"></router-view>
    </transition>
  </div>
</template>

<script>
import * as mobile from "./config/mUtils";
import * as getData from "./service/getData";
import { mapState, mapMutations, mapActions } from "vuex";

import wx from 'weixin-js-sdk'
export default {
  name: "app",
  data() {
    return {
      transitionName: ""
    };
  },
  computed: {},
  mounted() {
    window.addEventListener("popstate", ()=> {
      this.$store.state.isBack =true; 
    });
    let url = window.location.href.split('#')[0]
    getData.share(encodeURIComponent(url)).then(res => {  //配置微信API
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appid, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, //// 必填，生成签名的时间戳
        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名，见附录1
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone'
        ]
      })
      let shareCont = {
          title: '凯艺娱乐',
          shareContent: '香港凯艺娱乐发展有限公司（SUPREME ART ENTERTAINMENT  LTD.），现主要业务包括明星经纪代理、艺人推广等。',
          url: url,
          imgUrl: 'http://static1.joubn.com/static/logo.png'
        };
        mobile.wxshare(wx, shareCont)
    })
  },
  methods: {},
  watch: {
    $route() {
      if(this.$store.state.isBack ){
        this.transitionName = "slide-right";
      }else{
        this.transitionName = "slide-left";
      }
      this.$store.state.isBack = false
      /* VueRouter.prototype.goBack = function() {
        this.isBack = true;
        window.history.go(-1);
      };


      var isBack = this.$router.isBack; 
      if (isBack) {
        this.transitionName = "slide-right";
      } else if (this.$router.isBack != null) {
        this.transitionName = "slide-left";
      }
      this.$router.isBack = false; */
    }
  }
};
</script>




<style lang="scss">
@import "assets/css/base";
@import "assets/font/iconfont.css";
@import "assets/css/swiper-3.4.2.min.css";
#app {
  // position: absolute;
  // top:0;
  // left:0;
  // overflow: hidden;
  //@include wh(100%,100%);
  background-color: #707c89;
}
.Router {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all ease .2s;
  overflow: hidden;
}
.slide-left-enter,
.slide-right-leave-active {
  transform: scale(1.5);
    opacity: 0;
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: scale(.5);
    opacity: 0;
}
</style>




// WEBPACK FOOTER //
// App.vue?3c1da4a5